import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import AppLayout from '../Layout/AppLayout.vue'
import '../styles/application.css'

createInertiaApp({
  title: (title) => (title ? `${title} · UP Aviation` : 'UP Aviation'),

  resolve: (name) => {
    const pages = import.meta.glob('../Pages/**/*.vue', { eager: true })
    const page = pages[`../Pages/${name}.vue`]

    if (!page) throw new Error(`Página Inertia não encontrada: ${name}`)

    // Layout persistente: a sidebar/topbar não remontam entre navegações.
    // Uma página pode declarar `layout: null` (defineOptions) para ficar sem
    // moldura — é o caso do Login. Por isso o teste é por "não definido", e
    // não `||`, que trataria null como ausência.
    if (page.default.layout === undefined) page.default.layout = AppLayout

    return page
  },

  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .mount(el)
  },
})
